// Per-store currency formatting for dress prices.
//
// Each store has its own currency (e.g. Singapore = SGD, Jakarta = IDR). Prices
// are entered and displayed in the store's currency. IDR has no minor units in
// practice, so we render it with no decimals; SGD and others use 2.

const CURRENCY_SYMBOLS: Record<string, string> = {
  SGD: 'S$',
  IDR: 'Rp',
  USD: '$',
};

export const currencySymbol = (currency?: string): string => {
  if (!currency) return '$';
  return CURRENCY_SYMBOLS[currency.toUpperCase()] || currency.toUpperCase();
};

// Formats an amount in the given currency, e.g. formatPrice(181527750, 'IDR')
// → "Rp 181,527,750". Accepts number or numeric string (Sequelize returns
// DECIMAL columns as strings).
export const formatPrice = (amount: number | string | null | undefined, currency?: string): string => {
  const n = typeof amount === 'string' ? parseFloat(amount) : (amount ?? 0);
  const safe = isNaN(n) ? 0 : n;
  const code = (currency || 'SGD').toUpperCase();
  // IDR is conventionally shown without decimals.
  const fractionDigits = code === 'IDR' ? 0 : 2;
  const formatted = safe.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
  return `${currencySymbol(code)} ${formatted}`;
};
